import { Component, OnInit, ViewChild, HostListener, AfterViewInit, ChangeDetectorRef, Input } from '@angular/core';
import { ProductoService } from '../producto.service';
import { Producto } from '../producto';
import { MdbTablePaginationComponent, MdbTableDirective, ModalDirective } from 'angular-bootstrap-md';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Impuesto } from '../Impuesto';
import { ImpuestoService } from '../impuesto.service';
import * as XLSX from 'xlsx';  
import { AlertService } from 'ngx-alerts';
import { UnidadService } from '../unidad.service';
import { Unidades } from '../unidades';
import { ProductoPrecio } from '../productoPrecio';
import { grupoProducto } from '../grupoProducto';
import { GrupoProductoService } from '../grupoProducto.service';

import { SafeUrl } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.scss']
})
export class ProductoComponent implements OnInit {

  blod: Blob;
  urlImagen: SafeUrl | null = null;
  productos: Producto[]=[];
  impuestos: Impuesto[];
  unidades: Unidades[];
  unidadesVenta: Unidades[];
  grupos: grupoProducto[];
  precio: ProductoPrecio;
  url:string = '';
  listaPrecios: ProductoPrecio[]=[];
  productoTerminado:boolean;
  listaPreciosActualizar: ProductoPrecio[]  = [];
  productoActuliza: Producto;
  listaClientesActulizar: Producto[] = [];
  selecProduc: Producto;
  verficar:Boolean;
  editForm: FormGroup;
  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, { static: true })  mdbTable: MdbTableDirective;


  

  @ViewChild('processingModal') public mdbModal: ModalDirective;
  @ViewChild('modalPrecios') public modalPrecios: ModalDirective;
  data: Producto[] = [];
  previous: any = [];
  isLoadingResults = true;
  fileName= 'Productos.xlsx';  
  printWindow:Window;

  etiqueta(){
 
    

  }



listarUnidades()
{

  this.apiUnidad.getUnidadesCompra(localStorage.getItem('id')).subscribe((
    data: Unidades[]) => {
    this.unidades = data;
    console.log(this.unidades);
    
  }
    , err => {
      console.log(err);
      
    });

}

elimiarPrecio(varPrecios:ProductoPrecio){
  this.api.eliminarPrecio(varPrecios.id).subscribe(
  data  => {
    this.alertService.success("Se elimino con exito..");
    this.listaProductoPrecio();
  },
  
  error  => {
  
 this.alertService.danger(error);
  
  });
}


listarUnidadesVenta()
{

  this.apiUnidad.getUnidadesVenta(localStorage.getItem('id')).subscribe((
    data: Unidades[]) => {
    this.unidadesVenta = data;
    console.log(this.unidadesVenta);
    
  }
    , err => {
      console.log(err);
      
    });

}



listarGrupos()
{

  this.apiGrupo.getGrupo(localStorage.getItem('id')).subscribe((
    data: grupoProducto[]) => {
    this.grupos = data;
    console.log(this.grupos);
    
  }
    , err => {
      console.log(err);
      
    });

}


onFileChanged(event) {
  const file = event.target.files[0];
  
  let fileReader = new FileReader();
  fileReader.readAsDataURL(file); // read file as data url

  fileReader.onload = (event) => { // called once readAsDataURL is completed
    console.log( event.target.result);
   this.url= event.target.result as string
   this.actulizaImagen( this.url)
 
  }

}

  constructor(config: NgbModalConfig, 
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
     private apiGrupo: GrupoProductoService,
     private apiUnidad: UnidadService,
     private alertService: AlertService,
     private apiImpuesto: ImpuestoService, 
     private api: ProductoService,
      private cdRef: ChangeDetectorRef,
       private formBuilder: FormBuilder, private ruter: Router) {

    config.backdrop = 'static';
    config.keyboard = false;

   }

   open(content,varPrododucto: Producto) {
    this.modalService.open(content);
    this.urlImagen=varPrododucto.imagen
    //this.productoTerminado=varPrododucto.productoTerminado
    this.mensaje(varPrododucto);
    this.cargarPrecios(varPrododucto);
    
  }
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }


  imprimirEtiqueta(texto){
    const printContent = document.getElementById(texto);
   this.printWindow = window.open();
   this. printWindow.document.open('text/plain')
   this. printWindow.document.write("^XA^FXTest ZPL^FS^FO50,100^A0N,89^FDHello ZPL^FS^XZ");
   this.  printWindow.document.close();
   this.  printWindow.focus();
   this.  printWindow.print();
   this.  printWindow.close();
    
  }


  listarProducto(){
    this.api.getProducto(localStorage.getItem('id'))
    .subscribe((
      data: Producto[]) => {
      this.productos = data;
      console.log(this.productos);
      this.mdbTable.setDataSource(this.productos);

      this.previous = this.mdbTable.getDataSource();
    }
      , err => {
        console.log(err);
        this.isLoadingResults = false;
      });



  }

  ngOnInit() {
    this.precio= new ProductoPrecio();
    this.selecProduc= new Producto();
 
    this.listarUnidades();

     this.listarGrupos();
    this.api.getProducto(localStorage.getItem('id'))
      .subscribe((
        data: Producto[]) => {
        this.productos = data;
        console.log(this.productos);
        this.mdbTable.setDataSource(this.productos);

        this.previous = this.mdbTable.getDataSource();
      }
        , err => {
          console.log(err);
          this.isLoadingResults = false;
        });

        this.editForm = this.formBuilder.group({
          codigo: ["0"],
          codigoPrincipal: [""],
          codigoAuxiliar: [""],
          nombre: [""],
          valorUnitario: [""],
          tipoProducto: [""],
          valorCaja: [0, ],
          valorLibra: [0, ],
          iva: [""],
          marca: [""],
          ice: [""],
          idUnidad: [0, ],
          irbpnr: [""],
          tipoId: [0, ],
          costo: [0, ],
          utilidad: [0, ],
          enviado: ["", ],
          productoTerminado: [false, ],
        });
    


  }


  exportexcel() 
    {
       /* table id is passed over here */   
       const element = document.getElementById('mdbTable'); 
       const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

       /* generate workbook and add the worksheet */
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

       /* save to file */
       XLSX.writeFile(wb, this.fileName);
			
    }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.productos = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.productos = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

  eliminarProducto(id: number) {
     
    if(confirm("Está seguro de eliminar")) {
   
    this.api.eliminarProducto(id).subscribe(

      data  => {
        this.alertService.success("Se elimino con exito..");
        this.listarProducto();
      
      },
      
      error  => {
      
     this.alertService.danger(error);
      
      }
      
      );

    }
 
 

  }

 printer(entidad:Producto){

   let pvp1,pvp2;


    this.api.getProductoPrecio(entidad.codigo.toString(), localStorage.getItem('id'))
    .subscribe((
      data: ProductoPrecio[]) => {
      this.listaPrecios = data;
      if(this.listaPrecios.length>0){
      pvp1='PVP '+this.listaPrecios[0].precioVenta;
      }
      if(this.listaPrecios.length>1){
        pvp2="";
        }else{
          pvp2="";
        }

        if (localStorage.getItem('id')=='508'){
        this.api.getEtiquetaVentaPink(entidad.nombre,entidad.codigoPrincipal,pvp2,pvp1).subscribe((file1) => {
    
        this.blod = new Blob([file1], { type: 'application/pdf' });
        const url1 = window.URL.createObjectURL(this.blod);
        this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
        var downloadURL = URL.createObjectURL(this.blod);
        window.open(downloadURL);
    
      }
      );
    }

    if (localStorage.getItem('id')=='590'){
      this.api.getEtiquetaVentaJUMP(entidad.nombre,entidad.codigoPrincipal,pvp2,pvp1).subscribe((file1) => {
  
      this.blod = new Blob([file1], { type: 'application/pdf' });
      const url1 = window.URL.createObjectURL(this.blod);
      this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
      var downloadURL = URL.createObjectURL(this.blod);
      window.open(downloadURL);
  
    }
    );
  }
    if (localStorage.getItem('id')=='511'){
      this.api.getEtiquetaVentaHerz(entidad.nombre,entidad.codigoPrincipal,pvp2,pvp1).subscribe((file1) => {
  
      this.blod = new Blob([file1], { type: 'application/pdf' });
      const url1 = window.URL.createObjectURL(this.blod);
      this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
      var downloadURL = URL.createObjectURL(this.blod);
      window.open(downloadURL);
  
    }
    );
  }
    
  if (localStorage.getItem('id')=='453' || localStorage.getItem('id')=='503' ){
      this.api.getEtiquetaVenta(entidad.nombre,entidad.codigoPrincipal,pvp2,pvp1).subscribe((file1) => {
    
        this.blod = new Blob([file1], { type: 'application/pdf' });
        const url1 = window.URL.createObjectURL(this.blod);
        this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
        var downloadURL = URL.createObjectURL(this.blod);
        window.open(downloadURL);
    
      }
      );
    }
  if (Number.parseInt(localStorage.getItem('id'))===9010){
      this.api.getEtiquetaVenta(entidad.nombre,entidad.codigoPrincipal,pvp2,pvp1).subscribe((file1) => {
    
        this.blod = new Blob([file1], { type: 'application/pdf' });
        const url1 = window.URL.createObjectURL(this.blod);
        this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
        var downloadURL = URL.createObjectURL(this.blod);
        window.open(downloadURL);
    
      }
      );
    }
    if ( localStorage.getItem('id')=='80002' || localStorage.getItem('id')=='80003'|| localStorage.getItem('id')=='9004'){
      this.api.getEtiquetaVentaImpoHerrague(entidad.nombre,entidad.codigoPrincipal,pvp2,pvp1).subscribe((file1) => {
    
        this.blod = new Blob([file1], { type: 'application/pdf' });
        const url1 = window.URL.createObjectURL(this.blod);
        this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
        var downloadURL = URL.createObjectURL(this.blod);
        window.open(downloadURL);
    
      }
      );
    }

    



    }
    
      , err => {
        console.log(err);
        this.isLoadingResults = false;
      });
      
    
    

  
 }

  listaProductoPrecio(){
    if (this.precio.idProducto>0){
    this.api.getProductoPrecio(this.precio.idProducto.toString(), localStorage.getItem('id'))
    .subscribe((
      data: ProductoPrecio[]) => {
      this.listaPrecios = data;
      console.log(this.listaPrecios);
    }
      , err => {
        console.log(err);
        this.isLoadingResults = false;
      });
      
    }
   
  }

  agregarPrecios(){
    if (this.precio.idProducto>0){
    this.listaProductoPrecio();
    this.precio.id=0;
    this.precio.idEmisor= Number(localStorage.getItem('id'));
    this.listaPreciosActualizar[0] = this.precio;
    if (this.precio.idUnidad>0){
    if (this.precio.precioVenta>0){
    this.api.setActulizarProductoPrecio(this.listaPreciosActualizar)
    .subscribe(

      data  => {
        this.alertService.success("Se guardo con exito...");
        this.api.getProductoPrecio(this.precio.idProducto.toString(), localStorage.getItem('id'))
        .subscribe((
          data: ProductoPrecio[]) => {
          this.listaPrecios = data;
          console.log(this.listaPrecios);
         
         
        }
          , err => {
            console.log(err);
            this.isLoadingResults = false;
          });
        },
      
        error  => {
        
       this.alertService.danger(error)
        
        }
        
        );
       
      }else{
        this.alertService.warning('Registre PVP');
      
      }
    }else{
        this.alertService.warning('Registre Unidad Venta');
      }
    
    }else{
      this.alertService.warning('Debe guardar el producto, para poner el precio...')
    }
  
  }

  actulizaImagen(imagen) {
  
    this.productoActuliza = new Producto();
    this.productoActuliza.codigo = this.editForm.controls['codigo'].value;
    this.productoActuliza.codigoAuxiliar = this.editForm.controls['codigoAuxiliar'].value;
    this.productoActuliza.codigoPrincipal = this.editForm.controls['codigoPrincipal'].value;
    this.productoActuliza.costo = this.editForm.controls['costo'].value;
    this.productoActuliza.ice = "N";
    this.productoActuliza.irbpnr = "N";
    this.productoActuliza.imagen =imagen
    this.productoActuliza.marca = this.editForm.controls['marca'].value;
    if  (this.editForm.controls['iva'].value=='2'){
      this.productoActuliza.iva = "S";
    }else{
      this.productoActuliza.iva = "N";
    }

    // this.productoActuliza.iva=this.editForm.controls['tipoCliente'].value;
    this.productoActuliza.nombre = this.editForm.controls['nombre'].value;

    this.productoActuliza.tipoProducto = this.editForm.controls['tipoProducto'].value;
    this.productoActuliza.valorUnitario = this.editForm.controls['valorUnitario'].value;
    this.productoActuliza.tipoId= this.editForm.controls['tipoId'].value;
    this.productoActuliza.idUnidad = this.editForm.controls['idUnidad'].value;
    this.productoActuliza.idEmisor = Number(localStorage.getItem('id'));
    this.productoActuliza.utilidad =this.editForm.controls['utilidad'].value;
    this.productoActuliza.marca =this.editForm.controls['marca'].value;
    this.productoActuliza.enviado = "S";
    this.productoActuliza.productoTerminado = this.editForm.controls['productoTerminado'].value;
    this.listaClientesActulizar[0] = this.productoActuliza;
    this.verficar=false;
    if (this.productoActuliza.codigo==0){
      this.productoActuliza.enviado = "S";
      this.productos.forEach(element => {
            if (element.codigoPrincipal==this.productoActuliza.codigoPrincipal){
             this.verficar=false;
            }
      });
    }
    if (this.verficar==false){
    this.api.setActulizarProducto(this.listaClientesActulizar).subscribe(

      data  => {
        this.productoActuliza=data;
        this.precio.idProducto=data.codigo;
        this.alertService.success("Se actualizo con exito..");
        this.mdbModal.hide();
        this.api.getProducto(localStorage.getItem('id'))
        .subscribe((
          data: Producto[]) => {
          this.productos = data;
          console.log(this.productos);
          this.mdbTable.setDataSource(this.productos);
    
          this.previous = this.mdbTable.getDataSource();
        }
          , err => {
            console.log(err);
            this.isLoadingResults = false;
          });
       
      
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
    }else{
      this.alertService.warning("Codigo de Barras existe...");
    }
   
   
  }


  onSomeAction(event){
    if(event.keyCode===13){
    
    }
   }
   sendit(data) {
    console.log(data);
  }
  
  handleKeyupEnter(event, value) {
    console.log(event)
    if(event.code=="Enter")
    event.preventDefault();

  }
  actulizar() {
    
    this.productoActuliza = new Producto();
    this.productoActuliza.codigo = this.editForm.controls['codigo'].value;
    this.productoActuliza.codigoAuxiliar = this.editForm.controls['codigoAuxiliar'].value;
    this.productoActuliza.codigoPrincipal = this.editForm.controls['codigoPrincipal'].value;
    this.productoActuliza.costo = this.editForm.controls['costo'].value;
    this.productoActuliza.ice = "N";
    this.productoActuliza.irbpnr = "N";
    this.productoActuliza.productoTerminado = this.editForm.controls['productoTerminado'].value;
    this.productoActuliza.marca = this.editForm.controls['marca'].value;
    if  (this.editForm.controls['iva'].value=='2'){
      this.productoActuliza.iva = "S";
    }else{
      this.productoActuliza.iva = "N";
    }
    this.productoActuliza.imagen=this.url
    // this.productoActuliza.iva=this.editForm.controls['tipoCliente'].value;
    this.productoActuliza.nombre = this.editForm.controls['nombre'].value;
    this.productoActuliza.productoTerminado = this.editForm.controls['productoTerminado'].value;

    this.productoActuliza.tipoProducto = this.editForm.controls['tipoProducto'].value;
    this.productoActuliza.valorUnitario = this.editForm.controls['valorUnitario'].value;
    this.productoActuliza.tipoId= this.editForm.controls['tipoId'].value;
    this.productoActuliza.idUnidad = this.editForm.controls['idUnidad'].value;
    this.productoActuliza.idEmisor = Number(localStorage.getItem('id'));
    this.productoActuliza.utilidad =this.editForm.controls['utilidad'].value;
    this.productoActuliza.marca =this.editForm.controls['marca'].value;
    this.productoActuliza.enviado = "S";
    this.listaClientesActulizar[0] = this.productoActuliza;
    this.verficar=false;
    if (this.productoActuliza.codigo==0){
      this.productoActuliza.enviado = "S";
      this.productos.forEach(element => {
            if (element.codigoPrincipal==this.productoActuliza.codigoPrincipal){
             this.verficar=true;
            }
      });
    }
    if (this.verficar==false){
    this.api.setActulizarProducto(this.listaClientesActulizar).subscribe(

      data  => {
        this.productoActuliza=data;
        this.precio.idProducto=data.codigo;
        this.alertService.success("Se actualizo con exito..");
        this.mdbModal.hide();
        this.api.getProducto(localStorage.getItem('id'))
        .subscribe((
          data: Producto[]) => {
          this.productos = data;
          console.log(this.productos);
          this.mdbTable.setDataSource(this.productos);
    
          this.previous = this.mdbTable.getDataSource();
        }
          , err => {
            console.log(err);
            this.isLoadingResults = false;
          });
       
      
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
    }else{
      this.alertService.warning("Codigo de Barras existe...");
    }
   
  
  }
  
  

  agregar(content){
    this.editForm = this.formBuilder.group({
      codigo: ["0"],
      codigoPrincipal: [""],
      codigoAuxiliar: [""],
      nombre: [""],
      valorUnitario: [""],
      tipoProducto: [""],
      valorCaja: [0, ],
      valorLibra: [0, ],
      iva: [""],
      ice: [""],
      marca: [""],
      idUnidad: [0, ],
      irbpnr: [""],
      tipoId: [0, ],
      costo: [0, ],
      utilidad: [0, ],
      productoTerminado: [true, ],
    });
    this.productoTerminado=false
    this.precio.idProducto=0;
    this.listaPrecios = [];
    this.unidadesVenta =[];
       this.listarUnidadesVenta();
       this.listaProductoPrecio();
  
      
    this.modalService.open(content);
   // this.mdbModal.show();
  }


  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(100);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }

  listarImpuesto() {
    this.apiImpuesto.getImpuestos().subscribe((
      data: Impuesto[]) => {
      this.impuestos = data;
    });
  }

 cargarPrecios(varPrododucto: Producto){

   this.precio= new ProductoPrecio();
   this.selecProduc=varPrododucto;
   this.precio.idEmisor=Number.parseInt(localStorage.getItem('id'));
   this.precio.idProducto=varPrododucto.codigo;
   this.listarUnidadesVenta();
   this.api.getProductoPrecio(this.precio.idProducto.toString(), localStorage.getItem('id'))
   .subscribe((
     data: ProductoPrecio[]) => {
     this.listaPrecios = data;
     console.log(this.listaPrecios);
    // this.modalPrecios.ngOnDestroy();
   //  this.modalPrecios.show();
   }
     , err => {
       console.log(err);
       this.isLoadingResults = false;
     });



  
 
}

  mensaje(varPrododucto: Producto) {

    console.log(varPrododucto);

    this.editForm.controls['codigo'].setValue(varPrododucto.codigo);
    this.editForm.controls['codigoPrincipal'].setValue(varPrododucto.codigoPrincipal);
    this.editForm.controls['nombre'].setValue(varPrododucto.nombre);
    this.editForm.controls['valorUnitario'].setValue(varPrododucto.valorUnitario);
    this.editForm.controls['valorLibra'].setValue(varPrododucto.valorLibra);
    this.editForm.controls['valorCaja'].setValue(varPrododucto.valorCaja);
    this.editForm.controls['tipoProducto'].setValue(varPrododucto.tipoProducto);
    this.editForm.controls['idUnidad'].setValue(varPrododucto.idUnidad);
    this.editForm.controls['tipoId'].setValue(varPrododucto.tipoId);
    this.editForm.controls['tipoId'].setValue(varPrododucto.costo);
    this.editForm.controls['codigoAuxiliar'].setValue(varPrododucto.codigoAuxiliar);
    this.editForm.controls['tipoId'].setValue(varPrododucto.tipoId);
    this.editForm.controls['utilidad'].setValue(varPrododucto.utilidad);
    this.editForm.controls['costo'].setValue(varPrododucto.costo);
     this.editForm.controls['productoTerminado'].setValue(varPrododucto.productoTerminado);
    this.url=varPrododucto.imagen
    if (varPrododucto.iva=='S'){
      this.editForm.controls['iva'].setValue("2");
    }else{
      this.editForm.controls['iva'].setValue("6");
    }
    this.editForm.controls['ice'].setValue(varPrododucto.ice);
    this.editForm.controls['irbpnr'].setValue(varPrododucto.irbpnr);
    this.listarImpuesto();
    
//    this.mdbModal.show();


  }

}
